<template>
  <div class="home-page cg-page" style="padding-top: 0;">
    <div class="login-content">
      <Header></Header>
      <div class="landing-page">
        <div class="">
          <div class="home-prize">
            <div class="home1 ac mt50">
            </div>
          </div>
          <div class="span fs33 ac app-en text-outline" style="font-size:38px;color: #00a5fe">
            {{ $t('Subscription_failed') }}
          </div>
          <div class="ac mt50">
            <button class="btn day_btn" style="min-width: 350px;">
              <span @click="goLogin">{{ $t('subscribe') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/HeaderTwo'

export default {
  components: {
    Header
  },
  data() {
    return {
      list: [],
      account: '',
      password: '',
      isShow: false,
      type: 'daily',
      isEN: 'bur',
      mobile: '',
      msg: '',
    }
  },
  created() {
    let msg = this.$route.query.msg
    if (msg) {
      this.msg = msg
    }
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    goLogin() {
      this.$router.push({path: '/login'})
    },
  }
}
</script>
<style scoped>
.landing-page {
  padding-bottom: 77%;
}
.text-outline {
  -webkit-text-stroke: 1px #fff; /* 白色描边 */
  text-stroke: 1px #fff; /* 兼容性写法 */
}

</style>



// WEBPACK FOOTER //
// src/page/errors.vue